"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));
var _flow = _interopRequireDefault(require("lodash/fp/flow"));
var _concat = _interopRequireDefault(require("lodash/fp/concat"));
var _join = _interopRequireDefault(require("lodash/fp/join"));
var _string = require("@active/core/string");
var _i18n = require("@active/react-utils/i18n");
var _getActiveElement = _interopRequireDefault(require("@active/react-utils/dom/getActiveElement"));
var _createPresenter = _interopRequireDefault(require("./createPresenter"));
var _utils = require("../Form/utils");
var _Menu = _interopRequireDefault(require("../Menu"));
var _AllSelectedValueType = _interopRequireDefault(require("./AllSelectedValueType"));
var _ComboBox = require("../ComboBox");
var _excluded = ["addon", "preAddon", "postAddon", "aria-labelledby", "children", "className", "disabled", "hasError", "hasWarning", "isLoading", "menuClass", "menuStyle", "menuAutoWidth", "menuPlacement", "multiSelectionOptions", "onBlur", "onChange", "onMenuClose", "onMenuOpen", "placeholder", "renderValue", "size", "suppressInnerEmptyMenu", "type", "value", "omitSelectedOption", "renderTag", "closeExceptionSelectors"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MENU_GAP = {
  xs: 24 * 0.1,
  sm: 30 * 0.1,
  md: 40 * 0.1,
  lg: 50 * 0.1
};
var DEFAULT_MULTI_SELECTION_OPTIONS = {
  allSelectedValueType: _AllSelectedValueType["default"].ACTUAL_VALUES
};
var Dropdown = function Dropdown(_ref, ref) {
  var addon = _ref.addon,
    preAddon = _ref.preAddon,
    postAddon = _ref.postAddon,
    ariaLabelledby = _ref['aria-labelledby'],
    children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    hasError = _ref.hasError,
    hasWarning = _ref.hasWarning,
    isLoading = _ref.isLoading,
    menuClass = _ref.menuClass,
    menuStyle = _ref.menuStyle,
    menuAutoWidth = _ref.menuAutoWidth,
    menuPlacement = _ref.menuPlacement,
    _ref$multiSelectionOp = _ref.multiSelectionOptions,
    multiSelectionOptions = _ref$multiSelectionOp === void 0 ? DEFAULT_MULTI_SELECTION_OPTIONS : _ref$multiSelectionOp,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onMenuClose = _ref.onMenuClose,
    onMenuOpen = _ref.onMenuOpen,
    placeholder = _ref.placeholder,
    renderValue = _ref.renderValue,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    suppressInnerEmptyMenu = _ref.suppressInnerEmptyMenu,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'single' : _ref$type,
    value = _ref.value,
    _ref$omitSelectedOpti = _ref.omitSelectedOption,
    omitSelectedOption = _ref$omitSelectedOpti === void 0 ? true : _ref$omitSelectedOpti,
    renderTag = _ref.renderTag,
    _ref$closeExceptionSe = _ref.closeExceptionSelectors,
    closeExceptionSelectors = _ref$closeExceptionSe === void 0 ? [] : _ref$closeExceptionSe,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useLocale = (0, _i18n.useLocale)(),
    i18n = _useLocale.i18n;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    closeMenuExceptionEls = _useState2[0],
    setCloseMenuExceptionEls = _useState2[1];
  var dropdownRef = (0, _react.useRef)();
  var menuRef = (0, _react.useRef)(null);
  var rootRef = (0, _react.useMemo)(function () {
    return ref || dropdownRef;
  }, [ref, dropdownRef]);
  var _useSelectOnlyComboBo = (0, _ComboBox.useSelectOnlyComboBox)({
      comboBoxRef: rootRef,
      disabled: disabled,
      listBoxRef: menuRef,
      onBlur: onBlur,
      triggerExceptions: closeMenuExceptionEls
    }),
    expanded = _useSelectOnlyComboBo.expanded,
    collapse = _useSelectOnlyComboBo.collapse;
  var presenter = (0, _react.useMemo)(function () {
    return (0, _createPresenter["default"])({
      i18n: i18n,
      multiSelectionOptions: multiSelectionOptions,
      omitSelectedOption: omitSelectedOption,
      suppressInnerEmptyMenu: suppressInnerEmptyMenu,
      type: type
    });
  }, [i18n, type, multiSelectionOptions, omitSelectedOption, suppressInnerEmptyMenu]);
  var dropdownBtnId = "dropdown-label-".concat((0, _react.useId)());
  var listboxId = "dropdown-listbox-".concat((0, _react.useId)());
  var isItemSelected = (0, _react.useCallback)(function (itemValue) {
    return presenter.isItemSelected(itemValue, value, children);
  }, [children, presenter, value]);
  var handleCloseMenu = (0, _react.useCallback)(function () {
    collapse();
    onMenuClose === null || onMenuClose === void 0 || onMenuClose();
  }, [collapse, onMenuClose]);
  var handleOpenMenu = (0, _react.useCallback)(function () {
    onMenuOpen === null || onMenuOpen === void 0 || onMenuOpen();
  }, [onMenuOpen]);
  var onItemSelect = (0, _react.useCallback)(function (itemValue) {
    onChange === null || onChange === void 0 || onChange(presenter.emitValue(itemValue, value, children));
  }, [children, onChange, presenter, value]);
  (0, _react.useEffect)(function ensureMenuFocusWhenValueChange() {
    var _menuRef$current;
    if (expanded && !((_menuRef$current = menuRef.current) !== null && _menuRef$current !== void 0 && _menuRef$current.contains((0, _getActiveElement["default"])()))) {
      var _menuRef$current2;
      (_menuRef$current2 = menuRef.current) === null || _menuRef$current2 === void 0 || _menuRef$current2.focus({
        preventScroll: true
      });
    }
  }, [value, expanded, menuRef]);
  var ariaProps = {
    role: 'combobox',
    tabIndex: disabled ? undefined : 0,
    'aria-disabled': disabled
  };
  var closeMenuExceptionSelector = (0, _flow["default"])((0, _concat["default"])(['.dropdown-clear-tags-btn i', '.tag-group .tag .ic-cross-bold']), (0, _join["default"])(','))(closeExceptionSelectors);
  (0, _react.useEffect)(function () {
    var _rootRef$current;
    setCloseMenuExceptionEls(Array.from(((_rootRef$current = rootRef.current) === null || _rootRef$current === void 0 ? void 0 : _rootRef$current.querySelectorAll(closeMenuExceptionSelector)) || []));
  }, [value, closeMenuExceptionSelector, rootRef]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    "data-testid": "dropdown-root",
    className: (0, _classnames["default"])('dropdown', (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, "dropdown-".concat(size), size && size !== 'md'), 'dropdown-with-tag', type === 'tag' && !(0, _isEmpty["default"])(value)), "expanded", !isLoading && expanded), 'has-warning', hasWarning), 'has-error', hasError), "loading", isLoading), "disabled", disabled), className),
    ref: rootRef,
    "aria-controls": listboxId,
    "aria-expanded": expanded,
    "aria-haspopup": "listbox",
    "aria-labelledby": (0, _string.combineWith)(' ')(ariaLabelledby, dropdownBtnId)
  }, ariaProps, (0, _utils.omitFormProps)(rest)), addon, preAddon, /*#__PURE__*/_react["default"].createElement(presenter.DropdownButton, {
    id: dropdownBtnId,
    onChange: onChange,
    value: value,
    isLoading: isLoading,
    disabled: disabled,
    placeholder: placeholder,
    presenter: presenter,
    renderValue: renderValue,
    renderTag: renderTag,
    size: size
  }, children), postAddon, /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropdown-icon",
    "aria-hidden": "true"
  })), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    closeExceptions: closeMenuExceptionEls,
    closeOn: presenter.menuCollapseBehavior,
    distance: MENU_GAP[size],
    focusOnOpen: false,
    id: listboxId,
    isItemSelected: isItemSelected,
    onClose: handleCloseMenu,
    onOpen: handleOpenMenu,
    onItemSelect: onItemSelect,
    open: expanded,
    placement: menuPlacement,
    ref: menuRef,
    refElement: rootRef.current,
    sameWidth: !menuAutoWidth,
    type: "listbox",
    className: menuClass,
    style: menuStyle,
    "aria-multiselectable": type === 'multiple' ? true : undefined,
    "aria-labelledby": ariaLabelledby
  }, presenter.renderChildren(value, children)));
};
var Composed = (0, _compose["default"])(_react.memo, _react["default"].forwardRef)(Dropdown);
Composed.defaultProps = {
  initialValue: null
};
var _default = exports["default"] = Composed;